import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { UserChangePassword } from '../../services';

export const fetchUserChangePassword = createAsyncThunk(
    'userChangePassword/fetchUserChangePassword',
    async ({ id, currentPass, newPass }) => {
        const response = await UserChangePassword(id, currentPass, newPass)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const userChangePasswordSlice = createSlice({
    name: 'userChangePassword',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserChangePassword.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUserChangePassword.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchUserChangePassword.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default userChangePasswordSlice.reducer;
